'use client'

import type { ProductBrandProps } from '@maestro/commerce-blocks/components/product-brand/product-brand.types'

import classNames from 'classnames'
import { useTranslations } from 'next-intl'

import { Link } from '@pearlconvert/ui/components/link'

import '@maestro/commerce-blocks/components/product-brand/styles/product-brand.scss'

const ProductBrand = (props: ProductBrandProps) => {
  const { brand, className } = props
  const t = useTranslations('commerce-blocks')

  if (!brand) {
    return
  }
  return brand.urlPath ? (
    <Link
      href={'/' + brand.urlPath}
      className={classNames('product-brand', className)}
      tabIndex={-1}
    >
      <span className="sr-only">{t('_globals.brand')}:</span>
      {brand.name}
    </Link>
  ) : (
    <div
      className={classNames('product-brand', 'product-brand--text', className)}
    >
      <span className="sr-only">{t('_globals.brand')}:</span>
      {brand.name}
    </div>
  )
}

export default ProductBrand
